import React from 'react'
import Text from './Text'

const Heading = ({ children, as = 'h2',  ...rest }) => (
  <Text fontSize={as === "h1" ? 5 : 3} as={as} variant="primary" {...rest}>
    {children}
  </Text>
)

export default Heading